module.exports = __webpack_public_path__ + "static/media/ycba.13c340d3.jpg";